import {
  generateKey,
  DomainAPI,
  Channel,
  APIKey,
  Authorization,
} from "../utils/setting";
import { checkResponse } from "../utils/checkResponse";
const shortLinks = {
  state: {
    apiKey: {},
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    get(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/serviceApiKeys/get";

      return fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1 && result.data) {
            _this.setState({ apiKey: result.data });
          }
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.message };
        });
    },
    create(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/serviceApiKeys/create";

      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
        body: JSON.stringify({
          secretKey: payload.secretKey,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result && result.code === 1) {
            _this.setState({ apiKey: result.data });
          } else {
            if (payload.snackbar)
              payload.snackbar(
                result.message || "Something went wrong",
                "error"
              );
          }
          return result;
        })
        .catch((error) => {
          if (payload.snackbar)
            payload.snackbar(error.message || "Something went wrong", "error");
          return { code: 0, error: error, message: error.message };
        });
    },
    delete(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/serviceApiKeys/delete";

      return fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token,
        },
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result && result.code === 1) {
            _this.setState({ apiKey: {} });
          } else {
            if (payload.snackbar)
              payload.snackbar(
                result.message || "Something went wrong",
                "error"
              );
          }
          return result;
        })
        .catch((error) => {
          if (payload.snackbar)
            payload.snackbar(error.message || "Something went wrong", "error");
          return { code: 0, error: error, message: error.message };
        });
    },
  }),
};

export default shortLinks;
